import { format } from "date-fns";
import { apiGet } from "./apiClient";

/**
 * Retrieves audit data for a specific assignment.
 * @param context - The context object containing assignment information.
 * @returns - A promise that resolves to the audit data.
 */
const fetchAuditData = async (context) => {
  const { assignmentDate, pulloutDivision } = context;
  const apiDate = format(assignmentDate, "dd-MMM-yyyy");
  return apiGet(`/auditLog/${apiDate}/${pulloutDivision}`, "fetching audit log");
};

export default fetchAuditData;
